﻿import { Component, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BuildADoorService, ProductService } from '../shared/services';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-db-home',
    templateUrl: './db-home.component.html',
    styleUrls: ['./db-home.component.css']
})
export class DoorBuilderHomeComponent {
    zipCode = new FormControl(null);

    constructor(public dbService: BuildADoorService, public productService: ProductService, public router: Router, private changeDetector: ChangeDetectorRef, private activeRoute: ActivatedRoute) { }

    ngOnInit() {
        this.activeRoute.queryParams.subscribe(params => {
            let productName = params['productName'];
            if (productName) {
                this.dbService.startOver();
                this.dbService.getProductGroups().subscribe(result => {
                    if (result) {
                        if (result['productGroups']) {
                            this.dbService.customerDesignedDoor.deliveryOption = "deliverOnly";
                            let productGroups = result['productGroups'];
                            productGroups.sort((a, b) => Number(a['minBasePrice']) > Number(b['minBasePrice']) ? 1 : (Number(b['minBasePrice']) > Number(a['minBasePrice']) ? -1 : 0));
                            let incomingProductGroup = productGroups.find(pg => pg.identifier.toLowerCase().replace(/\s+/g, '') === productName.toLowerCase());
                            this.dbService.setProductGroupSelectionSync(incomingProductGroup);
                            this.dbService.getStyles().subscribe(sResult => {
                                if (sResult && sResult['styles']) {
                                    if (this.dbService.customerDesignedDoor && this.dbService.customerDesignedDoor.productGroup && !this.dbService.selectedStyle) {
                                        let styleToSet = sResult['styles'].find(s => s._id === this.dbService.customerDesignedDoor.productGroup.style._id);
                                        this.dbService.selectedStyle = styleToSet;
                                        this.dbService.customerDesignedDoor.windSpeed = null;
                                        this.dbService.customerDesignedDoor.impactType = null;
                                        this.dbService.customerDesignedDoor.isWindSpeedAnswered = true;
                                        let width = params['w'];
                                        let height = params['h'];
                                        if (width && height) {
                                            this.dbService.customerDesignedDoor.width.feet = +width;
                                            this.dbService.customerDesignedDoor.width.inches = 0;
                                            this.dbService.customerDesignedDoor.height.feet = +height;
                                            this.dbService.customerDesignedDoor.height.inches = 0;

                                            let panelCode = params['panel'];
                                            if (panelCode) {
                                                this.productService.getDoorDesignsForProductGroup(this.dbService.getPricesQuery()).subscribe(result => {
                                                    if (result) {
                                                        if (result['doorDesigns']) {
                                                            if (result['doorDesigns'] && result['doorDesigns'].length > 0) {
                                                                let design = result['doorDesigns'].find(d => d.code.toLowerCase() === panelCode.toLowerCase());
                                                                let initializedDesign = this.dbService.initializeDoorDesign(design);
                                                                this.dbService.customerDesignedDoor.doorDesign = initializedDesign;

                                                                let insulationCode = params['ins'];
                                                                if (insulationCode && initializedDesign) {
                                                                    let ddInsOptionAndColors = initializedDesign.insulationOptionsAndColors.find(i => i.insulationOption.name.toLowerCase().includes(insulationCode.toLowerCase()));
                                                                    if (ddInsOptionAndColors) {
                                                                        this.dbService.customerDesignedDoor.insulation = ddInsOptionAndColors.insulationOption;
                                                                        let windowName = params['win'];
                                                                        if (windowName) {
                                                                            let window = null;
                                                                            if (ddInsOptionAndColors.windows && ddInsOptionAndColors.windows.length > 0) {
                                                                                window = ddInsOptionAndColors.windows.find(w => w.name.toLowerCase().replace(/\s/g, "") === windowName.toLowerCase())
                                                                            } else if (initializedDesign.windows && initializedDesign.windows.length > 0) {
                                                                                window = initializedDesign.windows.find(w => w.name.toLowerCase().replace(/\s/g, "") === windowName.toLowerCase());
                                                                            }
                                                                            this.dbService.customerDesignedDoor.window = window;
                                                                            if (window.isCustom) {
                                                                                let winAlign = params['wAlign'];
                                                                                if (winAlign) {
                                                                                    if (winAlign.toLowerCase() === 'left') {
                                                                                        this.dbService.customerDesignedDoor.setWindowLocations(this.dbService.customerDesignedDoor.LEFT_MOSAIC);
                                                                                    } else if (winAlign.toLowerCase() === 'right') {
                                                                                        this.dbService.customerDesignedDoor.setWindowLocations(this.dbService.customerDesignedDoor.RIGHT_MOSAIC);
                                                                                    }
                                                                                }
                                                                            }
                                                                            let glassTypeCode = params['gt'];
                                                                            if (glassTypeCode) {
                                                                                let glassType = window.glassTypes.find(gt => gt.code.toLowerCase().replace(/\s/g, "") === glassTypeCode.toLowerCase())
                                                                                let isGlassTypeInsulated = params['gtIns'];
                                                                                if (isGlassTypeInsulated && glassType.insulatedVersion) {
                                                                                    glassType = glassType.insulatedVersion;
                                                                                }
                                                                                this.dbService.customerDesignedDoor.glassType = glassType;
                                                                            }
                                                                        }
                                                                        let colorName = params['color'];
                                                                        if (colorName) {
                                                                            let color = ddInsOptionAndColors.colors.find(c => c.name.toLowerCase().replace(/\s/g, "").replace(/\//g, "-") === colorName.toLowerCase());
                                                                            if (color) {
                                                                                this.dbService.customerDesignedDoor.color = color;
                                                                            }
                                                                        }

                                                                    }
                                                                }
                                                            }
                                                        }
                                                        this.dbService.isFromURL = true;
                                                        this.router.navigate(['/door-builder/design']);
                                                    } else {
                                                        this.dbService.isFromURL = true;
                                                        this.router.navigate(['/door-builder/design']);
                                                    }
                                                });
                                            } else {
                                                this.dbService.isFromURL = true;
                                                this.router.navigate(['/door-builder/design']);
                                            }
                                        } else {
                                            this.dbService.isFromURL = true;
                                            this.router.navigate(['/door-builder']);
                                        }
                                    } else {
                                        this.dbService.isFromURL = true;
                                        this.router.navigate(['/door-builder']);
                                    }
                                } else {
                                    this.dbService.isFromURL = true;
                                    this.router.navigate(['/door-builder']);
                                }
                            });
                        } else {
                            this.dbService.isFromURL = true;
                            this.dbService.validateSelections();
                            this.router.navigate(['/door-builder']);
                        }
                    } else {
                        this.dbService.isFromURL = true;
                        this.dbService.validateSelections();
                        this.router.navigate(['/door-builder']);
                    }
                });
            } else {
                this.dbService.isFromURL = true;
                this.router.navigate(['/door-builder']);
            }
        });
    }

    ngAfterViewChecked() { this.changeDetector.detectChanges(); }

    onZipChange() { }

    onClickGetStarted() {
        this.dbService.zipcode = this.zipCode.value
        this.router.navigate(['/door-builder']);
    }
}